import { reportTransactionTypes } from '@constants/correspondent';
import type { TableHeader } from '@shared/components/table/types';
import { getLabel } from '@shared/utils';

const ALL_THREE = {
  [reportTransactionTypes.adminCorrespondent]: true,
  [reportTransactionTypes.correspondentConsultant]: true,
  [reportTransactionTypes.analystCorrespondent]: true,
};

export const TRANSACTIONS_REPORT_TABLE_HEADERS: TableHeader[] = [
  {
    id: 'transaction_id',
    name: 'transaction_id',
    label: getLabel('transaction'),
    isSortable: true,
    filter: ALL_THREE,
  },
  {
    id: 'transfer_date',
    name: 'transfer_date',
    label: getLabel('date'),
    isSortable: true,
    filter: ALL_THREE,
  },
  {
    id: 'transfer_hour',
    name: 'transfer_hour',
    label: getLabel('hour'),
    isSortable: true,
    filter: ALL_THREE,
  },
  {
    id: 'correspondent_name',
    name: 'correspondent_name',
    label: getLabel('correspondent'),
    isSortable: true,
    filter: { [reportTransactionTypes.analystCorrespondent]: true },
  },
  {
    id: 'subsidiary_name',
    name: 'subsidiary_name',
    label: getLabel('subsidiary'),
    isSortable: true,
    filter: ALL_THREE,
  },
  {
    id: 'cashier_name',
    name: 'cashier_name',
    label: getLabel('cashier'),
    isSortable: true,
    filter: ALL_THREE,
  },
  {
    id: 'transfer_type',
    name: 'transfer_type',
    label: getLabel('type'),
    isSortable: true,
    filter: ALL_THREE,
  },
  {
    id: 'amount',
    name: 'amount',
    label: getLabel('amount'),
    isSortable: false,
    filter: ALL_THREE,
  },
  {
    id: 'client_phone',
    name: 'client_phone',
    label: getLabel('phone'),
    isSortable: false,
    filter: ALL_THREE,
  },
  {
    id: 'status',
    name: 'status',
    label: getLabel('state'),
    isSortable: true,
    filter: ALL_THREE,
  },
  {
    id: 'state_name',
    name: 'state_name',
    label: getLabel('department'),
    isSortable: true,
    filter: { [reportTransactionTypes.analystCorrespondent]: true },
  },
  {
    id: 'city_name',
    name: 'city_name',
    label: getLabel('city'),
    isSortable: true,
    filter: { [reportTransactionTypes.analystCorrespondent]: true },
  },
];
